import { useDispatch } from 'react-redux';
import GlobalTableGenerator from '../../../../../components/GlobalTableGenerator';
import { useEffect } from 'react';
import { getTrainerSlot } from '../../../../../redux/features/CRDslice';
import { useSelector } from 'react-redux';

import { updateSlotTableHeader } from '../utils/updateSlotTableHeader';

export default function UpdateSlots({ trainer_id, setEditUpdateSlot }) {
  const dispatch = useDispatch();
  const trainerSlots = useSelector((state) => state.crd.trainerSlot?.data);
  const trainerSlotsLoading = useSelector((state) => state.crd.trainerSlot?.loading);

  useEffect(() => {
    if (trainer_id) dispatch(getTrainerSlot(trainer_id));
  }, [trainer_id, dispatch]);

  return (
    <GlobalTableGenerator
      rows={trainerSlots}
      columns={updateSlotTableHeader({ setEditUpdateSlot })}
      loading={trainerSlotsLoading}
      TableHeadStyle={{ bgcolor: '#d6ceceff' }}
    />
  );
}
